import { displayTextLabelValidator, nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
/**
 * Default Display Text for the Member Photo Uploader component.
 */
export const defaultMemberRewardListDisplayText = {
    modalHelpText: undefined,
    modalActionButtonLabel: 'View showtimes',
    availableRewardQuantityFormat: '${quantity} remaining',
    expiryCountdownFormat: '${days} days left',
    expiryDateFormat: 'Expires ${expiryDate|d|MMMM D, YYYY}',
    balanceCostFormat: '${balanceCost} pts',
    percentageOffDiscountFormat: '${discount}% off',
    priceOffDiscountFormat: '${discount} off',
    specialPriceDiscountFormat: 'Now ${price}',
    noRewardsErrorTitle: 'There are currently no rewards',
    noRewardsErrorMessage: 'Any rewards you receive will be shown here.',
    actionButtonLabel: 'See all rewards',
    failedToLoadDataTitle: 'Sorry, something went wrong.',
    failedToLoadDataMessage: 'Refresh your browser to try loading rewards again.'
};
export const memberRewardListDisplayTextValidator = Validator.object({
    modalHelpText: Validator.optional(displayTextLabelValidator),
    modalActionButtonLabel: nonEmptyStringValidator,
    availableRewardQuantityFormat: nonEmptyStringValidator,
    expiryCountdownFormat: nonEmptyStringValidator,
    expiryDateFormat: nonEmptyStringValidator,
    balanceCostFormat: nonEmptyStringValidator,
    percentageOffDiscountFormat: nonEmptyStringValidator,
    priceOffDiscountFormat: nonEmptyStringValidator,
    specialPriceDiscountFormat: nonEmptyStringValidator,
    noRewardsErrorTitle: nonEmptyStringValidator,
    noRewardsErrorMessage: nonEmptyStringValidator,
    actionButtonLabel: nonEmptyStringValidator,
    failedToLoadDataTitle: nonEmptyStringValidator,
    failedToLoadDataMessage: nonEmptyStringValidator
});
